import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "container", "template", "hidden" ]

  connect() {
    // Load existing specs on page load
    this.loadExistingSpecs()
  }

  addPair(event) {
    event.preventDefault()
    
    const content = this.templateTarget.innerHTML
      .replace(/NEW_RECORD/g, new Date().getTime())
    
    this.containerTarget.insertAdjacentHTML('beforeend', content)
    this.updateHiddenField()
  }

  removePair(event) {
    event.preventDefault()
    
    const pair = event.target.closest('.technical-spec-pair')
    if (pair) {
      pair.remove()
      this.updateHiddenField()
    }
  }

  updateHiddenField() {
    const specs = {}
    
    this.element.querySelectorAll('.technical-spec-pair').forEach(pair => {
      const key = pair.querySelector('input[name*="[key]"]')?.value
      const value = pair.querySelector('input[name*="[value]"]')?.value
      
      if (key && key.trim() !== '') {
        specs[key] = value || ''
      }
    })
    
    this.hiddenTarget.value = JSON.stringify(specs)
  }

  loadExistingSpecs() {
    try {
      const specsData = this.hiddenTarget.value
      if (!specsData || specsData === '{}') return
      
      const specs = JSON.parse(specsData)
      
      Object.entries(specs).forEach(([key, value]) => {
        const content = this.templateTarget.innerHTML
          .replace(/NEW_RECORD/g, new Date().getTime())
          .replace('value=""', `value="${this.escapeHtml(key)}"`)
          .replace('value=""', `value="${this.escapeHtml(value)}"`)
        
        this.containerTarget.insertAdjacentHTML('beforeend', content)
      })
    } catch (e) {
      console.error('Error loading technical specs:', e)
    }
  }

  escapeHtml(text) {
    const map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    }
    return text.replace(/[&<>"']/g, m => map[m])
  }
}
